import React from 'react';

function Footer() {
  return (
    <footer style={{
      position: "fixed",
      bottom: "0px",
      left: "0px",
      width: "100%",
      zIndex: "998"
    }}>
      <p>&copy; 2024 Destiny Uyi Akugbe. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
